var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcShareKakaoLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#FAE100"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.902,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 19.4683C24.6733 19.4683 18 25.3576 18 30.34C18 34.0734 20.4236 37.3665 24.1149 39.3234L22.5624 45.026C22.424 45.5316 22.998 45.9329 23.4382 45.642L30.2469 41.1231C30.8209 41.1791 31.4058 41.2118 32 41.2118C39.7311 41.2118 46 36.3445 46 30.34C46 25.3576 39.7311 19.4683 32 19.4683Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShareKakaoLarge);
export default __webpack_public_path__ + "static/media/ic_share_kakao_large.78a7d83a8b7e498224b4d8ae957da921.svg";
export { ForwardRef as ReactComponent };